import { useState, useEffect, useMemo } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentStatusInfo from "./PaymentStatusInfo";

const PaymentStatus = ({
  addedByStudentOrParentDirectly,
  initiatedByAdminFromOrgDashboardForStudent,
  initiatedByAdminFromOrgDashboardForParent,
}: {
  addedByStudentOrParentDirectly?: boolean;
  initiatedByAdminFromOrgDashboardForStudent?: boolean;
  initiatedByAdminFromOrgDashboardForParent?: boolean;
}) => {
  const [userId, setUserId] = useState<string>("");
  const [setupIntentClientSecret, setSetupIntentClientSecret] =
    useState<string>("");
  const [options, setOptions] = useState<any>();
  const [orgStripeAccountId, setOrgStripeAccountId] = useState<string | null>(
    null
  );
  const [paramsRead, setParamsRead] = useState(false);

  useEffect(() => {
    // Retrieve query params appended to your return_url by Stripe.js
    const queryParams = new URLSearchParams(window.location.search);
    const setup_intent_client_secret = queryParams.get(
      "setup_intent_client_secret"
    );
    const orgAcctId = queryParams.get("org_stripe_account_id");
    const incomingUserId = queryParams.get("user_id"); // student_id or parent_id

    if (setup_intent_client_secret !== null) {
      setSetupIntentClientSecret(setup_intent_client_secret);
      setOptions({ clientSecret: setup_intent_client_secret });
    }
    if (incomingUserId !== null) setUserId(incomingUserId);
    if (orgAcctId) setOrgStripeAccountId(orgAcctId);
    setParamsRead(true);
  }, []);

  // Build the Stripe object.
  // If NOT addedByStudentOrParentDirectly, scope it to the account the
  // SetupIntent is on: the one in the return URL, or Tadpole's platform account
  // when the URL has none (a customer made before the org had an account).
  const stripePromise = useMemo(() => {
    const pk = process.env
      .REACT_APP_STRIPE_PUBLISHABLE_KEY_TADPOLE_BILLING as string;
    if (!addedByStudentOrParentDirectly) {
      if (!paramsRead) return null; // wait until we have read the return URL
      return loadStripe(
        pk,
        orgStripeAccountId ? { stripeAccount: orgStripeAccountId } : undefined
      );
    }
    return loadStripe(pk);
  }, [addedByStudentOrParentDirectly, orgStripeAccountId, paramsRead]);

  if (!options || !stripePromise) {
    return null; // or your loading UI if you prefer
  }

  return (
    <Elements stripe={stripePromise} options={options}>
      {addedByStudentOrParentDirectly && (
        <PaymentStatusInfo setupIntentClientSecret={setupIntentClientSecret} />
      )}

      {initiatedByAdminFromOrgDashboardForStudent && (
        <PaymentStatusInfo
          studentIdIfInitiatedByAdminFromOrgDashboard={userId}
          setupIntentClientSecret={setupIntentClientSecret}
        />
      )}

      {initiatedByAdminFromOrgDashboardForParent && (
        <PaymentStatusInfo
          parentIdIfInitiatedByAdminFromOrgDashboard={userId}
          setupIntentClientSecret={setupIntentClientSecret}
        />
      )}
    </Elements>
  );
};

export default PaymentStatus;
